import React, { useEffect, useState } from "react";
import { Link, useLocation } from 'react-router-dom';
import { getProjects } from "../api/projectService";
import { sleep } from "../utils/sleep";
import img1 from "../assets/images/project/1.png"

const ProjectsSection = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  
   const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

    useEffect(() => {
    const fetchProjects = async () => {
      try {
        // simulate network delay (3 sec)
        //await sleep(3000);

        const data = await getProjects(); // asynchronous call
        setProjects(data);
      } catch (err) {
        setError("Failed to load projects.");
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
    }, []);
  
  // Loading Overlay
  if (loading) {
    return (
      <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
        <div className="spinner-border text-primary" role="status"></div>
        <span className="ms-3 fw-semibold">Loading projects...</span>
      </div>
    );
  }
  
   // Error Message
  if (error) {
    return (
      <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
        <p className="text-danger fs-7">{error}</p>
        <button
          className="btn btn-outline-primary mt-3"
          onClick={() => window.location.reload()}
        >
          Retry
        </button>
      </div>
    );
  }
  
   // Filter projects if on home page
  const filteredProjects = (currentPath === "/" || currentPath === "/home")
    ? projects.filter(project => project.showOnHome)
    : projects;
  
  return (
    <section className="py-5 bg-light projects-section">
      <div className="container text-center">
        <h2 className="fw-bold mb-4">Our <span className="text-primary-color">Projects</span></h2>
        <p className="text-muted small ps-3 mb-5">Discover how we deliver real-world impact through digital innovation.</p>

        <div className="row g-4">
          {filteredProjects.map((project) => (
            <div className="col-md-6 col-lg-4" key={project.id}>
              <div className="project-card shadow-sm rounded overflow-hidden h-100">
                <div className="project-img-wrapper">
                  <img
                    src={require(`../assets/images/project/${project.image}`)}
                    alt={project.title}
                    className="project-img w-100"
                  />
                </div>
                <div className="p-3 text-start">
                  <h5 className="fw-semibold mb-2">{project.title}</h5>
                  <p className="text-muted mb-2">{project.description}</p>
                  <Link to={`/projects/${project.id}`} className="text-primary-color text-decoration-none fw-medium">
                    View Project &rarr;
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

  {currentPath !== "/projects" && (
  <Link 
    to="/projects" 
    className="btn btn-outline-theme mt-4 px-4 py-2 fw-semibold"
  >
    View All Projects
  </Link>
)}
      </div>
    </section>
  );
};

export default ProjectsSection;
